import React, { Component } from "react";
import emailjs from "@emailjs/browser";
import { toast } from 'react-hot-toast';

class ContactEmail extends Component {
    state = { sending: false };

    handleSubmit = async (e) => {
        e.preventDefault();
        if (this.state.sending) return;

        this.setState({ sending: true });

        try {
            const SERVICE_ID = "service_c4mplge";
            const TEMPLATE_ID = "template_cm8u6bh";
            const PUBLIC_KEY = "xRNzYU8x7X8tbSrZu";

            await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY);

            e.target.reset();
            this.props.onSent?.();
            toast.success("Message envoyé ✅");
        } catch (err) {
            console.error(err);
            this.props.onSent?.();
            toast.error("Erreur lors de l’envoi ❌");
        } finally {
            this.setState({ sending: false });
        }
    };

    render() {
        const { sending } = this.state;

        return (
            <div className="row">
                <div className="col-lg-8 col-12">
                    <div className="contact-form">
                        <h3>Votre message</h3>
                        <form id="contact-form" onSubmit={this.handleSubmit}>
                            <div className="row row-10">
                                <div className="col-md-6 col-12 section-space--bottom--20">
                                    <input
                                        name="con_name"
                                        type="text"
                                        placeholder="Nom"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 col-12 section-space--bottom--20">
                                    <input
                                        name="con_email"
                                        type="email"
                                        placeholder="Email"
                                        required
                                    />
                                </div>
                                <div className="col-12">
                                    <textarea
                                        name="con_message"
                                        defaultValue={this.props.prefillMessage}
                                        placeholder="Votre message"
                                        required
                                    />
                                </div>
                                <div className="col-12">
                                    <button type="submit" disabled={sending}>
                                        {sending ? "Envoi..." : "Envoyer"}
                                    </button>
                                </div>
                            </div>
                        </form>
                        <p className="text-xs mt-2">
                            En envoyant ce formulaire, vous acceptez que vos données soient utilisées pour vous répondre.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactEmail;
